import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Drawer,
  Stack,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import styles from "./index.module.scss";

export interface IProps {
  children?: JSX.Element[] | JSX.Element;
}

interface IDeleteDialogProps extends IProps {
  visible: boolean;
  cancel: () => void;
}

const SystemSettingDrawer = (props: IDeleteDialogProps): JSX.Element => {
  const { t } = useTranslation();

  const cancel = () => {
    props.cancel();
  };


  return (
    <Drawer
      anchor={"right"}
      className={styles["drawer-popup-right"]}
      onClose={cancel}
      open={props.visible}
    >
  
        <div className="drawer-popup-header">
          <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
            {t("systemSettings.title")}
          </Typography>
          <Button
            onClick={() => {
              cancel();
            }}
          >
            <Close />
          </Button>
        </div>
        <div className="drawer-popup-body form-group">
          <Box sx={{ width: "100%", marginTop: "0" }}>
            <Stack direction="column">
              <LanguageSwitcher></LanguageSwitcher>
            </Stack>
          </Box>
        </div>
    </Drawer>
  );
};

export default SystemSettingDrawer;
